import React from 'react'
import PropTypes from 'prop-types'

import {
    RewardPropTypes,
    RewardsMetaPropTypes,
    BalancePropTypes,
} from 'containers/WGCWXShop/propTypes'

import WGCWXRewardsGrid from './components/WGCWXRewardsGrid/WGCWXRewardsGrid'

import { EVENT_REWARDS } from './translations'

import styles from './WGCWXRewards.scss'

class WGCWXRewards extends React.Component {
    static propTypes = {
        rewards: PropTypes.arrayOf(RewardPropTypes),
        rewardsMeta: RewardsMetaPropTypes,
        accountBalance: BalancePropTypes,
        selectReward: PropTypes.func.isRequired,
        isAddToComparisonAvailable: PropTypes.bool.isRequired,
    }

    render() {
        const {
            rewards,
            rewardsMeta,
            accountBalance,
            selectReward,
            isAddToComparisonAvailable,
        } = this.props

        return (
            <div className={styles.base}>
                <div className={styles.hangar} />
                <div className={styles.container}>
                    <div className={styles.content}>
                        <h1 className={styles.title}>
                            {EVENT_REWARDS}
                        </h1>
                        <WGCWXRewardsGrid
                            rewards={rewards}
                            rewardsMeta={rewardsMeta}
                            accountBalance={accountBalance}
                            selectReward={selectReward}
                            isAddToComparisonAvailable={isAddToComparisonAvailable}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default WGCWXRewards



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewards/WGCWXRewads.jsx